import styled from 'styled-components'

import { useSvgHref } from '../../svgHrefContext'

import * as brush from '../Brush'

const SYMBOL_ID = 'brush-3-def'

FullBrush3.filename = SYMBOL_ID
export function FullBrush3(props: brush.SpecificBrushProps): React.ReactElement {
    return (
        <brush.Brush {...props} viewBox="0 0 123 37" name="brush-3">
            <defs>
                <path
                    id={SYMBOL_ID}
                    d="m116.2 1.2346c1.034-2.2095-98.03 5.2891-111.24 8.8667-4.9656 1.2286 2.3514 1.6042 1.0215 2.8948-1.3299 1.2906-3.0469 0.5448-3.0469 0.5448s0.63069 1.264 1.2055 1.2422-2.4795 1.3342-2.9277 2.3052c-0.44822 0.971 2.5987 0.4262 1.4734 1.5182-1.1253 1.0921-0.71979 1.1005 0.72931 1.5703s-1.873 1.5497-0.28263 1.3463c1.5904-0.2034 1.6221 0.0339 2.2918 0.724s2.4832-1.7398 2.1299-0.0569 0.41504 2.6793 1.6949 3.1793c1.2798 0.5001-0.92071 0.8935-2.1483 2.0849-1.2276 1.1913 2.8106-0.5836 3.9492 0.5896 1.1385 1.1732-1.2313 1.5969 0.588 2.2434 1.8193 0.6466 2.9019 0.534 1.3394 1.3802-1.5624 0.8463-1.9938 3.6769 2.8967 4.8271 4.8904 1.1502 96.734-7.6487 96.54-8.6669s3.004 0.4346 4.539-1.0545c1.534-1.4892-1.481-0.7071-2.352-1.6042-0.87-0.8972 4.691-2.9445 3.172-3.0776-1.52-0.1332-1.58-1.0134 0.66-1.9807 2.239-0.9674 2.864-2.7798 3.37-6.3526s-5.651-2.9578-6.755-4.2992c-1.103-1.3415 3.693-0.90316 3.263-1.9601-0.43-1.0569 0.078-1.1477 1.598-1.0145 1.519 0.13318 0.974-3.0897-0.817-3.0934-1.792-0.00364-3.921 0.05322-2.887-2.1563z"
                />
            </defs>
            <use href={`#${SYMBOL_ID}`} />
        </brush.Brush>
    )
}

export const Brush3 = styled(function Brush3(
    props: brush.SpecificBrushProps
): React.ReactElement {
    const href = useSvgHref(SYMBOL_ID)
    return (
        <brush.Brush {...props} viewBox="0 0 123 37" name="brush-3">
            <use href={href} />
        </brush.Brush>
    )
})``
